module.exports = __webpack_public_path__ + "a399408c8e25ae47f3704e803e5c0023.svg";